export const firebaseConfig = {
  apiKey: "AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M",
  authDomain: "atresmicroserviciosdes.firebaseapp.com",
  databaseURL: "https://atresmicroserviciosdes.firebaseio.com",
  projectId: "atresmicroserviciosdes",
  storageBucket: "atresmicroserviciosdes.appspot.com",
  messagingSenderId: "574492392308"
};

export const firebaseConfig2 = {
  apiKey: "AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M",
  authDomain: "atresmicroserviciosdes.firebaseapp.com",
  databaseURL: "https://atresmicroserviciosdes-pactos-web.firebaseio.com",
  projectId: "atresmicroserviciosdes",
  storageBucket: "atresmicroserviciosdes.appspot.com",
  messagingSenderId: "574492392308"
};

export const firebaseConfig3 = {
  apiKey: "AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M",
  authDomain: "atresmicroserviciosdes.firebaseapp.com",
  databaseURL: "https://atresmicroserviciosdes-fcm.firebaseio.com/",
  projectId: "atresmicroserviciosdes",
  storageBucket: "atresmicroserviciosdes.appspot.com",
  messagingSenderId: "574492392308"
};
// export const firebaseConfig = {
//   apiKey: "AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M",
//   authDomain: "atresmicroserviciosdes.firebaseapp.com",
//   databaseURL: "https://pre1-elec-soldig.firebaseio.com",
//   projectId: "atresmicroserviciosdes",
//   storageBucket: "atresmicroserviciosdes.appspot.com",
//   messagingSenderId: "574492392308"
// };

// export const firebaseConfig2 = {
//   apiKey: "AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M",
//   authDomain: "atresmicroserviciosdes.firebaseapp.com",
//   databaseURL: "https://pre2-elec-soldig.firebaseio.com",
//   projectId: "atresmicroserviciosdes",
//   storageBucket: "atresmicroserviciosdes.appspot.com",
//   messagingSenderId: "574492392308"
// };

// export const firebaseConfig3 = {
//   apiKey: "AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M",
//   authDomain: "atresmicroserviciosdes.firebaseapp.com",
//   databaseURL: "https://pre3-elec-soldig.firebaseio.com",
//   projectId: "atresmicroserviciosdes",
//   storageBucket: "atresmicroserviciosdes.appspot.com",
//   messagingSenderId: "574492392308"
// };

export const firebaseConfigBackup = {
  apiKey: "AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M",
  authDomain: "atresmicroserviciosdes.firebaseapp.com",
  databaseURL: "https://atresmicroserviciosdes-tvbackup.firebaseio.com/",
  projectId: "atresmicroserviciosdes",
  storageBucket: "atresmicroserviciosdes.appspot.com",
  messagingSenderId: "574492392308"
};
